import React, { Fragment } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { Breadcrumbs, VerticalLinkGroup } from "components/navigation";
import { GreyFleetGeneral } from "pages/licence-checking/grey-fleet/settings/general/GreyFleetGeneral";
import { GreyFleetPolicy } from "pages/licence-checking/grey-fleet/settings/policy/GreyFleetPolicy";
import { GreyFleetHistory } from "pages/licence-checking/grey-fleet/settings/history/GreyFleetHistory";
import PropTypes from "prop-types";

export function GreyFleetSettings({
    breadcrumbs = []
}) {
    let routes = [
        {
            location: "/licence-checking/grey-fleet/settings/general",
            title: "Settings",
        },
        {
            location: "/licence-checking/grey-fleet/settings/policy",
            title: "Policy",
        },
        {
            location: "/licence-checking/grey-fleet/settings/history",
            title: "History",
        },
    ];

    return (
        <Fragment>
            <div className="row">
                <Breadcrumbs items={breadcrumbs} />
                <h1>Manage Grey Fleet</h1>
            </div>

            <div className="layout-cols">
                <div className="col side-col">
                    <div className="row">
                        <VerticalLinkGroup
                            links={routes}
                            exactRouteMatch={false}
                        ></VerticalLinkGroup>
                    </div>
                </div>
                <div className="col content-col">
                    <Routes>
                        <Route path="general" element={<GreyFleetGeneral />} />
                        <Route path="policy" element={<GreyFleetPolicy />} />
                        <Route path="history" element={<GreyFleetHistory />} />
                        <Route path="" element={<Navigate to="/licence-checking/grey-fleet/settings/general" replace />} />
                    </Routes>
                </div>
            </div>
        </Fragment>
    );
}

GreyFleetSettings.propTypes = {
    breadcrumbs: PropTypes.array,
};
